import Treebank from './Treebank';

export default Treebank;
